import React from 'react';
import {
    BrowserRouter,
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';
import NotificationIcon from './components/NotificationIcon';
import AuthCallback from './components/AuthCallback';
import Unauthorized from './components/Unauthorized';
import { isAuthenticated } from './utils/authStorage';
import './App.css';

/**
 * Protected Route component
 * Redirects to /unauthorized if user is not authenticated
 */
const ProtectedRoute: React.FC<{ component: React.ComponentType }> = ({ component: Component }) => (
    <Route
        render={() => (isAuthenticated() ? <Component /> : <Redirect to="/unauthorized" />)}
    />
);

/**
 * Main Notification UI component wrapper
 */
const NotificationPage: React.FC = () => (
    <div className="App">
        <header className="App-header">
            <NotificationIcon />
        </header>
    </div>
);

function App() {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/auth" component={AuthCallback} />
                <Route exact path="/unauthorized" component={Unauthorized} />
                <ProtectedRoute component={NotificationPage} />
            </Switch>
        </BrowserRouter>
    );
}

export default App;
